import {themr} from '@friendsofreactjs/react-css-themr';

import identifiers from '../identifiers';
import DateInput from './dateInput';
import style from './style.module.css';

export default themr(identifiers.dateInput, style)(DateInput);
